import React, { useState } from "react";

import { currencyFormat, formatCalendarDate } from "../../Utils/helper";
import EditOfferPopUp from "../Modals/EditOfferModal/EditOfferPopUp";
import GenericSettlementAddPopup from "../Modals/GenericSettlementAddPopup";

// import CurrentUserInfo from "./common/CurrentUserInfo";
// import SectionActionBar from "./SectionActionBar";
import SettlementEmptyMessage from "./SettlementEmptyMessage";

const SettlementOffers = ({
  offersObj,
  updateClientProceedStates,
  updateFeesState,
  trustLedgerObj,
  offerCombinations,
  groupedOffersObj,
  settlementObjProps,
}) => {
  const { updateTrustLedger } = trustLedgerObj;
  const { groupedOffers, updateGroupedOffersState } = groupedOffersObj;
  const {
    offers,
    showOfferModal,
    handleOfferClose,
    handleOfferShow,
    currentOffer,
    setCurrentOffer,
    updateOffersState,
  } = offersObj;
  const [showSettlementPopup, setShowSettlementPopup] = useState(false);
  const getOfferAmount = (offer) => {
    return offer?.offer_type?.id === 8 ? offer?.demand || 0.0 : offer?.amount || 0.0;
  };

  return (
    <>
      <div className="m-b-5">
        {offers.length === 0 && (
          <div className="table--no-card rounded-0 border-0 w-100">
            <table className="table table-borderless table-striped table-earning settlement-table">
              <thead>
                <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                  <th />
                  <th className="s-offer-date">{/*  */}</th>
                  <th>Party</th>
                  <th>Offer Type</th>
                  <th className="big-n-1">Note</th>

                  <th className="td-autosize text-center">
                    <i className="ic ic-15 ic-client" />
                  </th>
                  <th className="text-center td-autosize">
                    <i className="ic ic-15 ic-defendants" />
                  </th>
                  <th className="s-offer-date">Expires</th>
                </tr>
              </thead>
              <tbody id="body-table">
                <tr className="padding-tr-0">
                  <td colSpan={11}>
                    <SettlementEmptyMessage
                      name="INITIAL DEMAND OR OFFER"
                      onClick={() => setShowSettlementPopup(true)}
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        )}
        {
          <>
            {offers.length > 0 &&
              groupedOffers.map((group, parentIndex) => {
                const initialOffer = group?.offers_list?.slice()[0];
                const by = initialOffer.by_entity_client
                  ? `${initialOffer.by_entity_client.first_name || ""} ${initialOffer.by_entity_client.last_name || ""}`
                  : initialOffer?.by_defendant?.defendantType?.id === 1
                    ? `${initialOffer?.by_defendant?.first_name || ""} ${initialOffer?.by_defendant?.last_name || ""}`
                    : `${initialOffer?.by_defendant?.entity_name || ""}`;

                const party = initialOffer.entity_client
                  ? `${initialOffer.entity_client.first_name || ""} ${initialOffer.entity_client.last_name || ""}`
                  : initialOffer?.defendant?.defendantType?.id === 1
                    ? `${initialOffer?.defendant?.first_name || ""} ${initialOffer?.defendant?.last_name || ""}`
                    : `${initialOffer?.defendant?.entity_name || ""}`;
                const byIconClass = initialOffer?.by_entity_client ? "ic-client" : "ic-defendants";
                const partyIconClass = initialOffer?.entity_client ? "ic-client" : "ic-defendants";

                return (
                  <React.Fragment>
                    {parentIndex === 0 && (
                      <div className="settle-sub-action-bar">
                        <div className="w-100 height-25" style={{ height: "25px" }}>
                          <div
                            className="d-flex align-items-center justify-content-center height-25"
                            style={{ justifyContent: "center" }}
                          >
                            <span
                              style={{ gap: "5px" }}
                              className="text-uppercase d-flex align-items-center m-l-5 text-white fw-bold cursor-default"
                            >
                              {initialOffer?.offer_type?.name || ""} from{" "}
                              <i className={`${byIconClass} ic ic-15`} />
                              {by || ""} to <i className={`${partyIconClass} ic ic-15`} />
                              {party || ""}
                              {(
                                initialOffer?.by_defendant
                                  ? initialOffer?.by_insurance?.company
                                  : initialOffer?.insurance?.company
                              )
                                ? `, ${
                                    initialOffer?.by_defendant
                                      ? initialOffer?.by_insurance?.company
                                      : initialOffer?.insurance?.company
                                  }`
                                : ""}
                            </span>
                          </div>
                        </div>
                      </div>
                      // <SectionActionBar
                      //   sectionName={`${initialOffer?.offer_type?.name || ""} from ${by || ""} to ${party || ""}${
                      //     (
                      //       initialOffer?.by_defendant
                      //         ? initialOffer?.by_insurance?.company
                      //         : initialOffer?.insurance?.company
                      //     )
                      //       ? `, ${
                      //           initialOffer?.by_defendant
                      //             ? initialOffer?.by_insurance?.company
                      //             : initialOffer?.insurance?.company
                      //         }`
                      //       : ""
                      //   }`}
                      // />
                    )}
                    {parentIndex === 0 && (
                      <div className="table--no-card rounded-0 border-0 w-100 m-b-5">
                        <table className="table table-borderless table-striped table-earning settlement-table">
                          <thead>
                            <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                              <th />
                              <th className="s-offer-date">{/*  */}</th>
                              <th>Party</th>
                              <th>Offer Type</th>
                              <th className="big-n-1">Note</th>
                              <th className="td-autosize text-center">
                                <i className="ic ic-15 ic-client" />
                              </th>
                              <th className="text-center td-autosize">
                                <i className="ic ic-15 ic-defendants" />
                              </th>
                              <th className="s-offer-date">Expires</th>
                              {/* <th className="td-autosize text-end">Initial</th>
                              <th className="text-end td-autosize">Counter</th> */}
                            </tr>
                          </thead>
                          <tbody id="body-table" className="group-offer-table">
                            {group?.offers_list
                              .slice()
                              // .reverse()
                              ?.sort((a, b) => {
                                const dateA = new Date(
                                  a?.offer_type?.id === 8 ? a?.demand_date_sent : a?.date
                                );

                                const dateB = new Date(
                                  b?.offer_type?.id === 8 ? b?.demand_date_sent : b?.date
                                );

                                return dateB - dateA;
                              })
                              .map((offer, index) => {
                                const isClientOffer = !!offer?.by_entity_client;

                                return (
                                  <tr
                                    key={index}
                                    className="cursor-default"
                                    onClick={() => {
                                      setCurrentOffer(offer);
                                      handleOfferShow();
                                    }}
                                  >
                                    <td className="td-autosize">{index + 1}</td>
                                    <td className="s-offer-date">
                                      {formatCalendarDate(
                                        offer?.offer_type?.id === 8
                                          ? offer?.demand_date_sent
                                          : offer?.date
                                      )}
                                    </td>

                                    <td className="td-autosize">
                                      <div
                                        className="d-flex align-items-center justify-content-start"
                                        style={{
                                          gap: "5px",
                                        }}
                                      >
                                        <span className="d-flex align-items-center">
                                          {offer?.by_entity_client ? (
                                            <i className={"ic ic-15 ic-client"} />
                                          ) : (
                                            <i className={"ic ic-15 ic-defendants"} />
                                          )}
                                        </span>
                                        <span className="">
                                          {offer?.by_entity_client
                                            ? `${offer?.by_entity_client?.first_name || ""} ${offer?.by_entity_client?.last_name || ""}`
                                            : offer?.by_defendant
                                              ? offer?.by_defendant?.defendantType?.id === 1
                                                ? `${offer?.by_defendant?.first_name || ""} ${offer?.by_defendant?.last_name || ""}`
                                                : offer?.by_defendant?.entity_name || ""
                                              : ""}
                                        </span>
                                        {!offer?.by_entity_client && (
                                          <div
                                            className="d-flex align-items-center"
                                            style={{
                                              gap: "5px",
                                            }}
                                          >
                                            {(offer?.by_defendant
                                              ? offer?.by_insurance
                                              : offer?.insurance) && (
                                              <span className="d-flex align-items-center justify-content-center">
                                                <i className={"ic ic-15 ic-insurance"} />
                                              </span>
                                            )}
                                            {(offer?.by_defendant
                                              ? offer?.by_insurance
                                              : offer?.insurance) && (
                                              <span>
                                                {offer?.by_defendant
                                                  ? offer?.by_insurance?.company
                                                  : offer?.insurance?.company}
                                              </span>
                                            )}
                                          </div>
                                        )}
                                      </div>
                                    </td>

                                    <td className="td-autosize">
                                      {index === group?.offers_list?.length - 1 ? "Initial " : ""}{" "}
                                      {offer.offer_type.name}
                                    </td>
                                    <td className=" text-capitalize big-n-1">{offer.note}</td>

                                    <td className="td-autosize monospace-font text-end whitespace-SETTLE dollar-amount-value">
                                      {isClientOffer ? currencyFormat(getOfferAmount(offer)) : ""}
                                    </td>
                                    <td className="monospace-font td-autosize text-end whitespace-SETTLE dollar-amount-value">
                                      {!isClientOffer ? currencyFormat(getOfferAmount(offer)) : ""}
                                    </td>
                                    <td className="s-offer-date">
                                      {formatCalendarDate(offer.expiration_date)}
                                    </td>
                                  </tr>
                                );
                              })}

                            {groupedOffers.map((group, parentIndex) => {
                              const initialOffer = group?.offers_list?.slice()[0];
                              const by = initialOffer.by_entity_client
                                ? `${initialOffer.by_entity_client.first_name || ""} ${initialOffer.by_entity_client.last_name || ""}`
                                : initialOffer?.by_defendant?.defendantType?.id === 1
                                  ? `${initialOffer?.by_defendant?.first_name || ""} ${initialOffer?.by_defendant?.last_name || ""}`
                                  : `${initialOffer?.by_defendant?.entity_name || ""}`;

                              const party = initialOffer.entity_client
                                ? `${initialOffer.entity_client.first_name || ""} ${initialOffer.entity_client.last_name || ""}`
                                : initialOffer?.defendant?.defendantType?.id === 1
                                  ? `${initialOffer?.defendant?.first_name || ""} ${initialOffer?.defendant?.last_name || ""}`
                                  : `${initialOffer?.defendant?.entity_name || ""}`;
                              const byIconClass = initialOffer?.by_entity_client
                                ? "ic-client"
                                : "ic-defendants";
                              const partyIconClass = initialOffer?.entity_client
                                ? "ic-client"
                                : "ic-defendants";
                              return (
                                <>
                                  {parentIndex > 0 && (
                                    <tr className="offer-action-bar-row cursor-default">
                                      <td className="offer-action-bar-td" colSpan={11}>
                                        <div className="settle-sub-action-bar">
                                          <div
                                            className="w-100 height-25"
                                            style={{ height: "25px" }}
                                          >
                                            <div
                                              className="d-flex align-items-center justify-content-center height-25"
                                              style={{ justifyContent: "center" }}
                                            >
                                              <span
                                                style={{ gap: "5px" }}
                                                className="text-uppercase d-flex align-items-center m-l-5 text-white fw-bold cursor-default"
                                              >
                                                {initialOffer?.offer_type?.name || ""} from{" "}
                                                <i className={`${byIconClass} ic ic-15`} />
                                                {by || ""} to{" "}
                                                <i className={`${partyIconClass} ic ic-15`} />
                                                {party || ""}
                                                {(
                                                  initialOffer?.by_defendant
                                                    ? initialOffer?.by_insurance?.company
                                                    : initialOffer?.insurance?.company
                                                )
                                                  ? `, ${
                                                      initialOffer?.by_defendant
                                                        ? initialOffer?.by_insurance?.company
                                                        : initialOffer?.insurance?.company
                                                    }`
                                                  : ""}
                                              </span>
                                            </div>
                                          </div>
                                        </div>
                                        {/* <SectionActionBar
                                          sectionName={`${initialOffer?.offer_type?.name || ""} from ${by || ""} to ${party || ""}${
                                            (
                                              initialOffer?.by_defendant
                                                ? initialOffer?.by_insurance?.company
                                                : initialOffer?.insurance?.company
                                            )
                                              ? `, ${
                                                  initialOffer?.by_defendant
                                                    ? initialOffer?.by_insurance?.company
                                                    : initialOffer?.insurance?.company
                                                }`
                                              : ""
                                          }`}
                                        /> */}
                                      </td>
                                    </tr>
                                  )}

                                  {parentIndex > 0 && (
                                    <tr id="settle-tb-header" className="settle-t-4 cursor-default">
                                      <th />
                                      <th className="s-offer-date">{/*  */}</th>
                                      <th>Party</th>
                                      <th>Offer Type</th>
                                      <th className="big-n-1">Note</th>
                                      <th className="td-autosize text-center">
                                        <i className="ic ic-15 ic-client" />
                                      </th>
                                      <th className="text-center td-autosize">
                                        <i className="ic ic-15 ic-defendants" />
                                      </th>
                                      <th className="s-offer-date">Expires</th>
                                      {/* <th className="td-autosize text-end">Initial</th>
                                      <th className="text-end td-autosize">Counter</th> */}
                                    </tr>
                                  )}
                                  {parentIndex > 0 &&
                                    group?.offers_list
                                      .slice()
                                      // .reverse()
                                      ?.sort((a, b) => {
                                        const dateA = new Date(
                                          a?.offer_type?.id === 8 ? a?.demand_date_sent : a?.date
                                        );

                                        const dateB = new Date(
                                          b?.offer_type?.id === 8 ? b?.demand_date_sent : b?.date
                                        );

                                        return dateB - dateA;
                                      })
                                      .map((offer, index) => {
                                        const isClientOffer = !!offer?.by_entity_client;
                                        return (
                                          <tr
                                            key={index}
                                            className="cursor-default"
                                            onClick={() => {
                                              setCurrentOffer(offer);
                                              handleOfferShow();
                                            }}
                                          >
                                            <td className="td-autosize">{index + 1}</td>
                                            <td className="s-offer-date">
                                              {formatCalendarDate(
                                                offer?.offer_type?.id === 8
                                                  ? offer?.demand_date_sent
                                                  : offer?.date
                                              )}
                                            </td>

                                            <td className="td-autosize">
                                              <div
                                                className="d-flex align-items-center justify-content-start"
                                                style={{
                                                  gap: "5px",
                                                }}
                                              >
                                                <span className="d-flex align-items-center">
                                                  {offer?.by_entity_client ? (
                                                    <i className={"ic ic-15 ic-client"} />
                                                  ) : (
                                                    <i className={"ic ic-15 ic-defendants"} />
                                                  )}
                                                </span>
                                                <span className="">
                                                  {offer?.by_entity_client
                                                    ? `${offer?.by_entity_client?.first_name || ""} ${offer?.by_entity_client?.last_name || ""}`
                                                    : offer?.by_defendant
                                                      ? offer?.by_defendant?.defendantType?.id === 1
                                                        ? `${offer?.by_defendant?.first_name || ""} ${offer?.by_defendant?.last_name || ""}`
                                                        : offer?.by_defendant?.entity_name || ""
                                                      : ""}
                                                </span>
                                                {!offer?.by_entity_client && (
                                                  <div
                                                    className="d-flex align-items-center"
                                                    style={{
                                                      gap: "5px",
                                                    }}
                                                  >
                                                    {(offer?.by_defendant
                                                      ? offer?.by_insurance
                                                      : offer?.insurance) && (
                                                      <span className="d-flex align-items-center justify-content-center">
                                                        <i className={"ic ic-15 ic-insurance"} />
                                                      </span>
                                                    )}
                                                    {(offer?.by_defendant
                                                      ? offer?.by_insurance
                                                      : offer?.insurance) && (
                                                      <span>
                                                        {offer?.by_defendant
                                                          ? offer?.by_insurance?.company
                                                          : offer?.insurance?.company}
                                                      </span>
                                                    )}
                                                  </div>
                                                )}
                                              </div>
                                            </td>

                                            <td className="td-autosize">
                                              {index === group?.offers_list?.length - 1
                                                ? "Initial "
                                                : ""}{" "}
                                              {offer.offer_type.name}
                                            </td>
                                            <td className=" text-capitalize big-n-1">
                                              {offer.note}
                                            </td>

                                            <td className="td-autosize monospace-font text-end whitespace-SETTLE dollar-amount-value">
                                              {isClientOffer
                                                ? currencyFormat(getOfferAmount(offer))
                                                : ""}
                                            </td>
                                            <td className="monospace-font td-autosize text-end whitespace-SETTLE dollar-amount-value">
                                              {!isClientOffer
                                                ? currencyFormat(getOfferAmount(offer))
                                                : ""}
                                            </td>
                                            <td className="s-offer-date">
                                              {formatCalendarDate(offer.expiration_date)}
                                            </td>
                                          </tr>
                                        );
                                      })}
                                </>
                              );
                            })}
                          </tbody>
                        </table>
                      </div>
                    )}
                  </React.Fragment>
                );
              })}
          </>
        }
      </div>
      {showOfferModal && (
        <EditOfferPopUp
          show={showOfferModal}
          updateGroupedOffersState={updateGroupedOffersState}
          handleClose={handleOfferClose}
          offer={currentOffer}
          updateOffersState={updateOffersState}
          updateClientProceedStates={updateClientProceedStates}
          updateFeesState={updateFeesState}
          updateTrustLedger={updateTrustLedger}
          offerCombinations={offerCombinations}
        />
      )}
      {showSettlementPopup && (
        <GenericSettlementAddPopup
          show={showSettlementPopup}
          handleClose={() => setShowSettlementPopup(false)}
          _initialLabel={"An Initial Demand or Offer"}
          {...settlementObjProps}
        />
      )}
    </>
  );
};

export default SettlementOffers;
